import {
  Anchor,
  Collapsible,
  Flex,
  FlexMixin,
  IconChevronDown,
  IconChevronUp,
  Paragraph,
  TextButton,
} from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useListingUser } from '../../../hooks/useListingUser';
import { URLS } from '../../../constants/urls';
import {
  emitOpenVoucherSeeMoreDropdownEvent,
  emitOpenVoucherSeeMoreInfoLinkEvent,
} from '../../../../client/analytics/clickstreamEvents';

const StyledTextButton = styled(TextButton)`
  ${FlexMixin}
`;

export default function VoucherInformation({ incomeSourceId }) {
  const { user, listing } = useListingUser();

  function trackDropdownOpen() {
    emitOpenVoucherSeeMoreDropdownEvent(listing, user);
  }

  function trackSeeMoreInfoLinkClicked() {
    emitOpenVoucherSeeMoreInfoLinkEvent(listing, user);
  }

  const voucherInformationId = `${incomeSourceId}-voucher-info`;
  const linkId = `${incomeSourceId}-voucher-link`;
  return (
    <Collapsible defaultCollapsed>
      {(collapsed, toggle) => (
        <Flex direction="column">
          <StyledTextButton
            alignSelf="flex-start"
            icon={collapsed ? <IconChevronDown aria-hidden="true" /> : <IconChevronUp aria-hidden="true" />}
            onClick={() => {
              toggle();
              trackDropdownOpen();
            }}
            aria-expanded={!collapsed}
            aria-controls={voucherInformationId}
            aria-label={collapsed ? 'Learn more about vouchers' : 'Hide voucher information'}
          >
            See {collapsed ? 'more' : 'less'}
          </StyledTextButton>
          <div id={voucherInformationId}>
            {collapsed ? (
              ''
            ) : (
              <>
                <Paragraph marginBottom="sm">
                  Tenant-based vouchers are rental assistance payments funded by the federal government for helping
                  people afford decent, safe, and sanitary housing. If you accept this application, a local housing
                  agency will pay you the approved voucher amount directly every month. The tenant will be responsible
                  for paying any difference between your rent price and the approved voucher amount.{' '}
                  <Anchor
                    href={URLS.VOUCHER_FAQ_LINK}
                    onClick={trackSeeMoreInfoLinkClicked}
                    target="_blank"
                    id={linkId}
                  >
                    See more information
                  </Anchor>{' '}
                  about vouchers.
                </Paragraph>
                <Paragraph>
                  In some locations, it may be illegal to refuse to rent to a tenant because they use a voucher to pay
                  their rent; for legal advice, please consult a local attorney.
                </Paragraph>
              </>
            )}
          </div>
        </Flex>
      )}
    </Collapsible>
  );
}

VoucherInformation.propTypes = {
  incomeSourceId: PropTypes.string.isRequired,
};
